var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mixed-selection-empty"},[_c('a-empty',[_c('span',{attrs:{"slot":"image"},slot:"image"},[_c('a-icon',{style:({ fontSize: '50px', color: 'lightgray' }),attrs:{"type":"disconnect"}})],1),_c('span',{staticClass:"text-muted",attrs:{"slot":"description"},slot:"description"},[_vm._v("Mixed selection")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }